<template>
  <div>
    <vs-popup :title="$t(popupTitle)" :active.sync="showModal">
      <form v-if="showModal">
        <vs-input
          class="inputx mb-4 mt-1"
          v-model="model.name"
          name="documentName"
          :label="$t('Name')"
          v-validate="'required'"
        />
        <span class="text-danger text-sm" v-show="errors.has('documentName')">{{
          errors.first("documentName")
        }}</span>

        <label class="vs-input--label">{{ $t("CustomerType") }}</label>
        <v-select
          label="name"
          name="partyType"
          :options="partyTypes"
          v-model="model.partyType"
          :reduce="(x) => x.id"
          class="mb-4"
          v-validate="'required'"
          dir="rtl"
        >
        </v-select>
        <span class="text-danger text-sm" v-show="errors.has('partyType')">{{
          errors.first("partyType")
        }}</span>

        <label class="vs-input--label">{{ $t("SaleSystem") }}</label>
        <div v-if="salesTypes && loading">
          <v-select
            label="name"
            name="salesType"
            :options="salesTypes"
            :value="selectedSaleType"
            @input="changeSalesType"
            :reduce="(x) => x.id"
            v-model="model.salesType"
            class="mb-4"
            v-validate="'required'"
            dir="rtl"
          >
          </v-select>
        </div>
        <span class="text-danger text-sm" v-show="errors.has('salesType')">{{
          errors.first("salesType")
        }}</span>
        <vs-checkbox v-model="model.isRequired" class="mt-2 mb-4">{{
          $t("IsRequired")
        }}</vs-checkbox>
        <vs-button
          type="filled"
          class="float-right mb-4"
          @click.prevent="submitForm"
          >{{ $t("Save") }}</vs-button
        >
      </form>
    </vs-popup>
  </div>
</template>

<style lang="scss" scoped>
::v-deep .removeIco {
  float: left !important;
  top: 10px !important;
  left: 10px !important;
}
::v-deep .text-danger {
  position: relative;
  top: -0.75rem;
}
</style>

<script>
import { mapActions } from "vuex";
import { Validator } from "vee-validate";
import vSelect from "vue-select";

const dict = {
  custom: {
    documentName: {
      required: "لطفا نام را وارد نمایید.",
    },
    partyType: {
      required: "لطفا نوع مشتری را انتخاب نمایید.",
    },
    salesType: {
      required: "لطفا نوع سیستم فروش را انتخاب نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  props: {
    show: { default: false },
    model: {
      default: {},
    },
    keywords: {},
  },
  data() {
    return {
      popupTitle: "",
      partyTypes: [
        { name: "حقیقی", id: 0 },
        { name: "حقوقی", id: 1 },
      ],
      salesTypes: [
        { name: "فروش داخلی", id: 0 },
        { name: "مصرف‌کننده نهایی", id: 1 },
        { name: "فروش نمایندگان", id: 2 },
        { name: "فروش سازمانی", id: 3 },
      ],
      selectedSaleType: "",
      loading: false,
    };
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
  },
  methods: {
    ...mapActions({
      createDocument: "documentSetting/create",
      updateDocument: "documentSetting/update",
    }),
    changeSalesType(salesType) {
      this.model.salesType == salesType;
    },
    submitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.model.id != null) {
            this.updateDocument(this.model).then(() => {
              this.$swal({
                position: "center-center",
                type: "success",
                text: "رکورد مورد‌نظر با موفقیت ویرایش شد!",
                showConfirmButton: false,
                timer: 2000,
              });
              this.$emit("finish");
              this.model = {};
              this.$validator.reset();
            });
          } else {
            this.createDocument(this.model).then(() => {
              this.$swal({
                position: "center-center",
                type: "success",
                text: "رکورد مورد‌نظر با موفقیت ثبت شد!",
                showConfirmButton: false,
                timer: 2000,
              });
              this.$emit("finish");
              this.model = {};
              this.$validator.reset();
            });
          }
        } else {
          // form have errors
        }
      });
    },
  },
  watch: {
    show() {
      if (this.show == true) {
        if (this.model.id) {
          this.popupTitle = "EditDocument";
          setTimeout(() => {
            this.selectedSaleType = this.salesTypes.filter(
              (x) => x.id == this.model.customerType
            )[0].name;
            this.loading = true;
          }, 0);
        } else {
          this.popupTitle = "CreateDocument";
          this.loading = true;
        }
      }
      this.$validator.reset();
      this.selectedSaleType == "";
    },
  },
  components: {
    "v-select": vSelect,
  },
};
</script>
